module.exports = __webpack_public_path__ + "media/images/thumbs/biology/m_animation_cellular_respiration_7-f92151bfee6cc0ab8a2d87e90fbff83f.jpg";